import React, { useState, useEffect, useContext, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const TimelineEmail = ( { cid, comms } ) => {
    const [ subject, setSubject ] = useState( '' );
    const [ from, setFrom ] = useState( '' );
    const [ to, setTo ] = useState( '' );
    const [ cc, setCc ] = useState( '' );
    const [ bcc, setBcc ] = useState( '' );
    const [ body, setBody ] = useState( '' );

    const formatEmails = ( emails ) => {
        let e = '';
        if ( emails ) {
            if ( Array.isArray( emails ) ) {
                emails.forEach( f => {
                    if ( e.length ) {
                        e += ', ';
                    }
                    e += f.email;
                } );
            } else if ( typeof emails === 'string' ) {
                e = emails;
            } else {
                e = emails.email;
            }
        }
        return e;
    }

    useEffect( () => {
        if ( comms[cid] ) {
            setSubject( comms[cid].subject );
            setBody( comms[cid].body );
            setFrom( formatEmails( comms[cid].from ) );
            setTo( formatEmails( comms[cid].to ) );
            setCc( formatEmails( comms[cid].cc ) );
            setBcc( formatEmails( comms[cid].bcc ) );
        }
        // console.log( comms[cid] );
    }, [ cid, comms ] );

    return (
        <Container fluid className='p-0'>
            <Row className='pb-2'>
                <Col>
                    <Row>
                        <Col className='fw-bold' xs='auto'>
                            Subject:
                        </Col>
                        <Col className='p-0'>
                            {subject}
                        </Col>
                    </Row>
                    <Row>
                        <Col className='fw-bold' xs='auto'>
                            To:
                        </Col>
                        <Col className='p-0'>
                            {to}
                        </Col>
                    </Row>
                    {
                        ( cc && cc.length ) ? (
                            <Row>
                                <Col className='fw-bold' xs='auto'>
                                    Cc:
                                </Col>
                                <Col className='p-0'>
                                    {cc}
                                </Col>
                            </Row>
                        ) : (
                            null
                        )
                    }
                    {
                        ( bcc && bcc.length ) ? (
                            <Row>
                                <Col className='fw-bold' xs='auto'>
                                    Bcc:
                                </Col>
                                <Col className='p-0'>
                                    {bcc}
                                </Col>
                            </Row>
                        ) : (
                            null
                        )
                    }
                    <Row>
                        <Col className='fw-bold' xs='auto'>
                            From:
                        </Col>
                        <Col className='p-0'>
                            {from}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='pt-2 overflow-auto' style={ { maxHeight: '250px', borderTop: '1px solid var( --tf-blue )' } }>
                <Col dangerouslySetInnerHTML={ { __html: body } } />
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    comms: state.comms.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TimelineEmail );